import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRightIcon, ChevronRightIcon } from 'lucide-react';
import { useLanguage } from './LanguageContext';
import { findSeoRoute, type SeoRoute } from '../data/seo';

/* Visible breadcrumb + related capabilities, rendered at the top of the footer
   on pages that declare them in data/seo.ts. */
export function RelatedLinks() {
  const {
    lang
  } = useLanguage();
  const {
    pathname
  } = useLocation();
  const route = findSeoRoute(pathname);
  if (!route || route.path === '/') return null;
  const pick = (b: {
    fr: string;
    en: string;
  }) => lang === 'FR' ? b.fr : b.en;
  const chain: SeoRoute[] = [route];
  let parent = route.parent ? findSeoRoute(route.parent) : undefined;
  while (parent) {
    chain.unshift(parent);
    parent = parent.parent ? findSeoRoute(parent.parent) : undefined;
  }
  const home = findSeoRoute('/') as SeoRoute;
  const crumbs = [home, ...chain];
  const related = (route.related ?? []).map(p => findSeoRoute(p)).filter((r): r is SeoRoute => Boolean(r));
  return <div className="border-b border-[#E4E6EC] pb-10 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6" data-id="element-5803" data-mp="1t1mwxinf1u38">
      <nav aria-label={lang === 'FR' ? 'Fil d’Ariane' : 'Breadcrumb'} data-id="element-5804" data-mp="1j4rz71yyvxq0">
        <ol className="flex flex-wrap items-center gap-1.5 font-sans text-xs text-black/50" data-id="element-5805" data-mp="1j6l86nx1yu16">
          {crumbs.map((c, i) => <li key={c.path} className="flex items-center gap-1.5" data-id="element-5806" data-mp="2btfod8mu778u" data-mpi={i}>
              {i > 0 && <ChevronRightIcon className="w-3 h-3 text-black/30" aria-hidden="true" data-id="element-5807" data-mp="2brco7vryzxqe" />}
              {i === crumbs.length - 1 ? <span aria-current="page" className="text-black/70" data-id="element-5808" data-mp="22t0zjzanza0l">{pick(c.name)}</span> : <Link to={c.path} className="hover:text-indigo transition-colors duration-150" data-id="element-5809" data-mp="26tt9kurd1ixx">{pick(c.name)}</Link>}
            </li>)}
        </ol>
      </nav>
      {related.length > 0 && <nav aria-label={lang === 'FR' ? 'Pages liées' : 'Related pages'} className="flex flex-wrap items-center gap-x-5 gap-y-2" data-id="element-5810" data-mp="vg8pci09rcvt">
          <span className="font-sans text-[11px] font-semibold tracking-[0.16em] uppercase text-black/40" data-id="element-5811" data-mp="2y12xv51dkgar">{lang === 'FR' ? 'À voir aussi' : 'See also'}</span>
          {related.map(r => <Link key={r.path} to={r.path} className="group inline-flex items-center gap-1 font-sans text-sm text-black/70 hover:text-indigo transition-colors duration-150" data-id="element-5812" data-mp="2oa8cs3zv7mqw">
              {pick(r.name)}
              <ArrowRightIcon className="w-3.5 h-3.5 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-5813" data-mp="2fcobww5wzsgt" />
            </Link>)}
        </nav>}
    </div>;
}